/**
 * Numeração FDI — a fonte é `@bookdental/schemas` (odontograma/denticao.ts), que cobre a dentição
 * permanente e a decídua. react-odontogram usa ids no formato "teeth-{fdi}" — não documentado como
 * export da lib, inferido do payload do onChange (`{ id: "teeth-21", notations: { fdi: "21" } }`).
 */
export {
  FDI_LOWER_ARCH,
  FDI_LOWER_LEFT,
  FDI_LOWER_RIGHT,
  FDI_UPPER_ARCH,
  FDI_UPPER_LEFT,
  FDI_UPPER_RIGHT,
  formatarDentes,
  parseDentes as parseTeethToFdi,
} from "@bookdental/schemas";

export const fdiToOdontogramId = (fdi: string) => `teeth-${fdi}`;
